import { Box } from "@mui/material";

import { TOOLBAR_COLORS } from "../constants";

export const BADGE_KEYFRAMES = {
    "@keyframes mv-badge-pop": {
        "0%": { transform: "scale(0)", opacity: 0 },
        "100%": { transform: "scale(1)", opacity: 1 },
    },
    "@keyframes mv-badge-pop-out": {
        "0%": { transform: "scale(1)", opacity: 1 },
        "100%": { transform: "scale(0)", opacity: 0 },
    },
} as const;

export function ModificationPill({ label, phase }: { label: string | null; phase: "showing" | "collapsing" }) {
    const isCollapsing = phase === "collapsing";
    return (
        <Box
            aria-label={label ?? undefined}
            sx={{
                height: 20,
                maxWidth: isCollapsing ? 0 : 220,
                borderRadius: "10px",
                backgroundColor: TOOLBAR_COLORS.MODIFICATION_ORANGE,
                paddingLeft: isCollapsing ? 0 : "8px",
                paddingRight: isCollapsing ? 0 : "8px",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                animation: isCollapsing ? undefined : "mv-badge-pop 0.25s cubic-bezier(0.34,1.56,0.64,1) both",
                transition: isCollapsing
                    ? "max-width 0.35s ease-in, padding-left 0.35s ease-in, padding-right 0.35s ease-in"
                    : undefined,
            }}
        >
            {label && (
                <Box
                    component="span"
                    sx={{
                        fontSize: 12,
                        fontWeight: 600,
                        lineHeight: "16px",
                        letterSpacing: "0.25px",
                        color: TOOLBAR_COLORS.MODIFICATION_ORANGE_TEXT,
                        whiteSpace: "nowrap",
                        opacity: isCollapsing ? 0 : 1,
                        transition: isCollapsing ? "opacity 0.2s ease-out" : undefined,
                    }}
                >
                    {label}
                </Box>
            )}
        </Box>
    );
}

export function ModificationDot({ exiting }: { exiting: boolean }) {
    return (
        <Box
            aria-label="View has active modifications"
            sx={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                backgroundColor: TOOLBAR_COLORS.MODIFICATION_ORANGE,
                animation: exiting
                    ? "mv-badge-pop-out 0.25s cubic-bezier(0.34,1.56,0.64,1) both"
                    : "mv-badge-pop 0.3s cubic-bezier(0.34,1.56,0.64,1) both",
            }}
        />
    );
}
